import { render } from "./WelcomeBanner.vue?vue&type=template&id=a1f3a39e&scoped=true"
import script from "./WelcomeBanner.vue?vue&type=script&lang=js"
export * from "./WelcomeBanner.vue?vue&type=script&lang=js"

import "./WelcomeBanner.vue?vue&type=style&index=0&id=a1f3a39e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1f3a39e"]])

export default __exports__